import React from 'react';

import { useIntl } from 'react-intl-next';

import { Text } from '@atlaskit/primitives/compiled';

import { formatRestriction } from '../../common/utils';

import messages from './messages';
import { Condition } from './styled';
import { type TimeListProps } from './types';

export const TimeList = ({ data, enabled, beforeMessage }: TimeListProps) => {
	const { formatMessage } = useIntl();

	if (!enabled || data.length === 0) {
		return null;
	}

	return (
		<div>
			<Condition>
				{formatMessage(messages['and'], {
					strong: (str: React.ReactNode) => <Text as="strong">{str}</Text>,
				})}

				{beforeMessage && <span>{beforeMessage}</span>}

				{data.map((t, i) => {
					let isNextWeek = false;

					if (t.startDay && t.endDay) {
						const isBeforeDay = t.startDay > t.endDay;
						const isSameDay = t.startDay === t.endDay;
						const isSameDayButBeforeHour = isSameDay && t.startHour > t.endHour;

						isNextWeek = isBeforeDay || isSameDayButBeforeHour;
					}

					if (i === data.length - 1) {
						return (
							<Text as="strong" key={i}>
								{formatRestriction(t)}
								{isNextWeek ? ` ${formatMessage(messages.nextWeek)}` : ''}
							</Text>
						);
					}

					return (
						<Text as="strong" key={i}>
							{formatRestriction(t)}
							{isNextWeek ? ` ${formatMessage(messages.nextWeek)}` : ''},{' '}
						</Text>
					);
				})}
			</Condition>
		</div>
	);
};
